import type { Document, TextRange } from '@gitbook/slate';
/**
 * Unhang the range by setting the anchor to the start of the first block
 * and the focus to the end of the penultimate block.
 */
export function unhangRange(range: TextRange, document: Document): TextRange {
    const blocks = document.getBlocksAtRange(range);
    // can't unhange a range with only one block
    if (blocks.size <= 1) {
        return range;
    }
    const startBlock = blocks.first();
    const endBlock = blocks.takeLast(2).first();
    return startBlock
        ? range.moveAnchorToStartOf(startBlock).moveFocusToEndOf(endBlock ?? startBlock)
        : range;
}
